/**
 * Error classes for audience links
 */
/**
 * Error thrown when audience link code generation fails
 */
export class AudienceLinkCodeGenerationError extends Error {
    constructor(error) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AudienceLinkCodeGenerationError);
        }
        this.error = error;
        this.name = "AudienceLinkCodeGenerationError";
        this.message = `Failed to generate audience link code: ${this.error.message}`;
    }
}
/**
 * Error thrown when audience links fetch fails
 */
export class AudienceLinksFetchError extends Error {
    constructor(error) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AudienceLinksFetchError);
        }
        this.error = error;
        this.name = "AudienceLinksFetchError";
        this.message = `Failed to fetch audience links: ${this.error.message}`;
    }
}
/**
 * Error thrown when audience link toggle fails
 */
export class AudienceLinkToggleError extends Error {
    constructor(error) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AudienceLinkToggleError);
        }
        this.error = error;
        this.name = "AudienceLinkToggleError";
        this.message = `Failed to toggle audience link: ${this.error.message}`;
    }
}
/**
 * Error thrown when bulk audience link toggle fails
 */
export class BulkAudienceLinkToggleError extends Error {
    constructor(error) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BulkAudienceLinkToggleError);
        }
        this.error = error;
        this.name = "BulkAudienceLinkToggleError";
        this.message = `Failed to bulk toggle audience links: ${this.error.message}`;
    }
}
/**
 * Error thrown when updating audience link delivery path fails
 */
export class UpdateAudienceLinkDeliveryPathError extends Error {
    constructor(error) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UpdateAudienceLinkDeliveryPathError);
        }
        this.error = error;
        this.name = "UpdateAudienceLinkDeliveryPathError";
        this.message = `Failed to update audience link delivery path: ${this.error.message}`;
    }
}
//# sourceMappingURL=errors.js.map